export default __webpack_public_path__ + "static/media/FemaleHeadOccipital.c6611500.png";